module.exports = __webpack_public_path__ + "img/bolt.0f5213.svg";